import * as React from "react";

import { asArrayValue } from "common/components/component-helpers";
import { LOADING, asUI } from "common/components/types";
import { GlideFunctionalRenderer } from "common/components/uis";
import List from "../../ui/smart/list/list";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";

export const GridMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[list, itemUI]] = useForceValueProducers(getValueProducers, force, ctx);
    if (list === LOADING || itemUI === LOADING) return env.renderProgress();
    const arr = asArrayValue(list);
    return (
        <List appFeatures={env.appEnvironment.appFeatures} title="" hasUnevenRows={true} items={arr} topAlign={false}>
            {(item, i, columnWidth) => asUI(itemUI).render(item, env.with({ columnWidth }), i)}
        </List>
    );
};
